import styled from "@emotion/styled/macro";
import { Accordion, AccordionSummary, Box } from "@mui/material";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledContractFieldContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  background: theme.customColors.white,
  boxShadow: "0px 1.2824229001998901px 6.412113666534424px 0px #0000001A",
  borderRadius: "4px",
  position: "relative",
  padding: "24px",
  marginBottom: "16px",
  position: "relative",
}));
